<template>
  <div class="background-loader modal" v-if="show">
    <div class="preloader" aria-busy="true" aria-label="Carregando..." role="progressbar"></div>
  </div>
</template>
<script>
export default {
  computed: {
    show () {
      return this.$store.state.tcModalLoader.show
    }
  }
}
</script>
<style scoped>
  .ls-topbar:after {
    box-shadow: none;
  }
  .background-loader {
    background: #000;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    opacity: 0.4;
  }
  .preloader {
    height: 40px;
    width: 40px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  .preloader:before {
    content: "";
    display: block;
    position: absolute;
    left: -1px;
    top: -1px;
    height: 100%;
    width: 100%;
    -webkit-animation: rotation 1s linear infinite;
            animation: rotation 1s linear infinite;
    border: 2px solid #404040;
    border-top: 2px solid transparent;
    border-radius: 100%;
  }
  @media only screen and (min-width: 768px) {
    .preloader {
      height: 80px;
      width: 80px;
    }
    .preloader:before {
      left: -2px;
      top: -2px;
    }
  }
  @media only screen and (min-width: 1200px) {
    .preloader {
      height: 80px;
      width: 80px;
    }
  }
  @-webkit-keyframes rotation {
    from {
      -webkit-transform: rotate(0deg);
              transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(359deg);
              transform: rotate(359deg);
    }
  }
  @keyframes rotation {
    from {
      -webkit-transform: rotate(0deg);
              transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(359deg);
              transform: rotate(359deg);
    }
  }
</style>



// WEBPACK FOOTER //
// modal-loader.vue?3560d7ac